<template>
    <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
        <NavBar title="添加"/>
        <Form>
            <Field
                    clearable
                    v-model="name"
                    label="名称"
                    required
                    placeholder="请输入名称"
                    :rules="[{ required: true, message: '名称不为空' }]"
            />
            <Field
                    clearable
                    v-model="remark"
                    label="备注"
                    required
                    placeholder="请输入备注"
                    :rules="[{ required: true, message: '备注不为空' }]"
            />
            <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">提交</Button>
        </Form>
    </Popup>
</template>

<script>
    import {Popup, Form, Field, Button, NavBar} from "vant"


    export default {
        components: {Popup, Form, Field, Button, NavBar},
        props: {
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false}
        },
        data() {
            return {
                taskId: this.$route.params.id,
                name: null,
                remark: null,
                popupShow: false,
            }
        },
        computed: {
            // popupShow: {
            //     set(v) {
            //         return v;
            //     },
            //     get() {
            //         return this.show;
            //     }
            // }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('panel', this.type,)
            },
            submit() {
                this.$toast.loading("正在提交中...");
                this.$http.tokiot.prospect.taskItem.create({
                    taskId: this.taskId,
                    name: this.name,
                    remark: this.remark
                }).then(res => {
                    if (res) {
                        this.$toast.success("添加成功");
                        this.popupShow = !this.popupShow
                        this.$emit("onRefresh")
                    } else {
                        this.$toast.fail(res.message)
                    }
                })
            },
        },
        watch: {
            show(show) {
                this.popupShow = show
            }
        }
    }
</script>

<style scoped>

</style>